import React from 'react';
import { Drawer } from 'antd';
import SupplierForm from './SupplierForm';
import { CreateSupplierData, UpdateSupplierData, Supplier } from '../../services/supplierService';

interface SupplierModalMobileProps {
  visible: boolean;
  supplier?: Supplier;
  onSave: (data: CreateSupplierData | UpdateSupplierData) => Promise<void>;
  onCancel: () => void;
  loading?: boolean;
}

const SupplierModalMobile: React.FC<SupplierModalMobileProps> = ({
  visible,
  supplier,
  onSave,
  onCancel,
  loading = false,
}) => {
  const isEdit = !!supplier;
  return (
    <Drawer
      title={isEdit ? 'Cập nhật nhà cung cấp' : 'Thêm nhà cung cấp mới'}
      open={visible}
      onClose={onCancel}
      placement="bottom"
      height="90vh"
      bodyStyle={{ padding: 16, background: '#f5f6fa' }}
      destroyOnClose
      footer={null}
      className="supplier-mobile-modal"
    >
      {/* Render SupplierForm trực tiếp, KHÔNG bọc Card, KHÔNG có Modal bên trong */}
      <SupplierForm
        supplier={supplier}
        onSave={onSave}
        onCancel={onCancel}
        loading={loading}
        noCard
      />
    </Drawer>
  );
};

export default SupplierModalMobile;
